import script from "./ruleCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ruleCard.vue?vue&type=script&setup=true&lang=ts"

import "./ruleCard.vue?vue&type=style&index=0&id=2a9a14f2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a9a14f2"]])

export default __exports__